import PhotoRelatedSearchLinksContainer from '../src/PhotoRelatedSearchLinksContainer.tsx';
export default PhotoRelatedSearchLinksContainer;
